import { render, staticRenderFns } from "./NavCollapse.vue?vue&type=template&id=e5882d54&scoped=true&"
import script from "./NavCollapse.vue?vue&type=script&lang=js&"
export * from "./NavCollapse.vue?vue&type=script&lang=js&"
import style0 from "./NavCollapse.vue?vue&type=style&index=0&id=e5882d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5882d54",
  null
  
)

export default component.exports